import { mapActions, mapState } from 'vuex'

export default {
  computed: {
    ...mapState('users', ['user']),

    stateFirstName: {
      get () {
        return this.user.first_name
      },

      set (value) {
        this.setUserProperty({ property: 'first_name', value })
      }
    },

    stateLastName: {
      get () {
        return this.user.last_name
      },

      set (value) {
        this.setUserProperty({ property: 'last_name', value })
      }
    },

    stateEmail: {
      get () {
        return this.user.email
      },

      set (value) {
        this.setUserProperty({ property: 'email', value })
      }
    },

    stateRole: {
      get () {
        return this.user.role
      },

      set (value) {
        this.setUserProperty({ property: 'role', value })
      }
    },

    stateEnabled: {
      get () {
        return this.user.enabled
      },

      set (value) {
        this.setUserProperty({ property: 'enabled', value })
      }
    },

    stateUsername: {
      get () {
        return this.user.username
      },

      set (value) {
        this.setUserProperty({ property: 'username', value })
      }
    },

    stateAgency: {
      get () {
        return this.user.agency_id
      },

      set (value) {
        this.setUserProperty({ property: 'agency_id', value })
      }
    },

    stateGen: {
      get () {
        return this.user.gen
      },

      set (value) {
        this.setUserProperty({ property: 'gen', value })
      }
    },

    statePhone: {
      get () {
        return this.user.phone
      },

      set (value) {
        this.setUserProperty({ property: 'phone', value })
      }
    },

    stateUnenrolled: {
      get () {
        return this.user.unenrolled
      },

      set (value) {
        this.setUserProperty({ property: 'unenrolled', value })
      }
    },

    stateRegion: {
      get () {
        return this.user.region
      },

      set (value) {
        this.setUserProperty({ property: 'region', value })
      }
    }
  },

  methods: {
    ...mapActions('users', ['setUserProperty'])
  }
}
